/* eslint-disable */

import Auth from '../auth/Auth';

const auth = new Auth();

export const auth0Login = () => {
  auth.login("auth");
};

export const oktaLogin = () => {
  auth.login("okta");
}

export const handleAuthenticationAuth0 = (history, authData) => (dispatch) => {
  auth.handleAuthentication(authData, history, dispatch);
}

export const renewSession = (cookies, history) => async (dispatch) => {
  await auth.renewSession(cookies, history, dispatch);
}

export const isAuthenticatedAuth0 = () => async (dispatch) => {
  // Check whether the current time is past the
  // Access Token's expiry time
  dispatch({ type: 'CHECK_AUTHENTICATION_START' });

  if (auth.isAuthenticated()) {
    dispatch({ type: 'CHECK_AUTHENTICATION_SUCCESS', payload: { isAuthenticated: true } });
  } else {
    dispatch({ type: 'CHECK_AUTHENTICATION_FAIL' });
    dispatch({ type: 'OPEN_ERROR', payload: "CHECK_AUTHENTICATION_FAIL" });
  }
};


export const usernameChanged = text => ({
  type: 'USERNAME_CHANGED',
  text
})

export const passwordChanged = text => {

  return {
    type: 'PASSWORD_CHANGED',
    text
  }
}

export const checkAuthentication = (history, cookies) => async (dispatch) => {
  if (localStorage.getItem('isAuthenticated') === 'true' && localStorage.getItem('access_token') && auth.isAuthenticated()) {
    await auth.renewSession(cookies, history, dispatch);
  } else {
    dispatch({ type: 'CHECK_AUTHENTICATION_FAIL' });
    await localStorage.clear();
    if (
      history.location.pathname === "/consumer" || 
      history.location.pathname === "/certificates/check" ||
      history.location.pathname === "/reports/check") {
      history.push(history.location.pathname);
    } else {
      history.push('/');
    }
  }
}

export const getUsername = async () => {
  const username = await localStorage.getItem('username');
  if (username) {
    return username;
  }
  return undefined;
}

export const passwordVisibilityToggle = () => ({
  type: 'PASSWORD_VISIBILITY_TOGGLE'
})

export const getCurrentUser = () => {
  const user = auth.getUserProfile();
  return user;
}

export const getCurrentUserAddress = async () => {

  const user = auth.getUserProfile();
  const userAddress = user.app_metadata.address;

  return userAddress;
}

export const isCurrentUserAdmin = async () => {

  const user = auth.getUserProfile();
  const roles = user.roles;
  return roles.indexOf('admin') >= 0;
}


export const isCurrentUserCustomer = async () => {

  const user = auth.getUserProfile();
  const roles = user.roles;
  return roles.indexOf('customer') >= 0;
}

export const isCurrentUserCustomerOfCustomer = async () => {

  const user = auth.getUserProfile();
  const roles = user.roles;
  return roles.indexOf('customerOfCustomer') >= 0;
}

export const logoutStart = (cookies) => async (dispatch) => {
  auth.logout(cookies, dispatch);
};



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js